module.exports = __webpack_public_path__ + "static/img/Tela de Cadastro.6697daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de Cadastro.png
// module id = Dnrg
// module chunks = 0